__turbopack_context__.v({
  "accordion": "accordion-module-scss-module__xI6fZG__accordion",
  "body": "accordion-module-scss-module__xI6fZG__body",
  "button": "accordion-module-scss-module__xI6fZG__button",
  "details": "accordion-module-scss-module__xI6fZG__details",
  "heading": "accordion-module-scss-module__xI6fZG__heading",
  "summary": "accordion-module-scss-module__xI6fZG__summary",
});
